import { render } from "./CreatProjekt.vue?vue&type=template&id=7be3f0ba"
import script from "./CreatProjekt.vue?vue&type=script&lang=js"
export * from "./CreatProjekt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__